// extracted by mini-css-extract-plugin
module.exports = {"definition":"MobileChapterNumbers__definition","chapter-button-size":"MobileChapterNumbers__chapter-button-size","root":"MobileChapterNumbers__root","mobileSizing":"MobileChapterNumbers__mobileSizing","icon":"MobileChapterNumbers__icon font-size--icon--medium","container":"MobileChapterNumbers__container"};
    if(module.hot) {
      // 1790535734594
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  